import { environment } from '../../../environments/environment';
export function script() {
  window.BTrendererVar = new window.BTRenderer().initialize({
    brand_id: '1928062748156104704',
    key: environment.sportsBookFrameKey,
    themeName: `tank-tech-cards-1`,
    lang: "en",
    target: document.getElementById('betby'), minFrameHeight: 700,
    betSlipOffsetTop: 0,
    betslipZIndex: 999,
    cssUrls: ['https://fonts.googleapis.com/css2?family=Montserrat:ital, wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap'],
    fontFamilies: ['Montserrat, sans-serif', 'Roboto, sansserif'],
    onRouteChange: function () {
    },
    onLogin: function () {
    },
    onRegister: function () {
    },
    onSessionRefresh: function () {
    }
  })
}

export function tawkScript() {
  var Tawk_API = Tawk_API || {}, Tawk_LoadStart = new Date();
  (function () {
    var s1 = document.createElement("script"), s0 = document.getElementsByTagName("script")[0];
    s1.async = true;
    s1.src = environment.host.tawkScriptSrc;
    s1.charset = 'UTF-8';
    s1.setAttribute('crossorigin', '*');
    s0.parentNode.insertBefore(s1, s0);
  })();
}


export function intercomScript() {
  if (!window.Intercom) {
    window.intercomSettings = {
      api_base: "https://api-iam.intercom.io",
      app_id: "y19m6r74"
    };


    var w = window; var ic = w.Intercom; if (typeof ic === "function") { ic('reattach_activator'); ic('update', w.intercomSettings); } else { var d = document; var i = function () { i.c(arguments); }; i.q = []; i.c = function (args) { i.q.push(args); }; w.Intercom = i; var l = function () { var s = d.createElement('script'); s.type = 'text/javascript'; s.async = true; s.src = 'https://widget.intercom.io/widget/y19m6r74'; var x = d.getElementsByTagName('script')[0]; x.parentNode.insertBefore(s, x); }; if (document.readyState === 'complete') { l(); } else if (w.attachEvent) { w.attachEvent('onload', l); } else { w.addEventListener('load', l, false); } }
  }

}


